module.exports = __webpack_public_path__ + "static/img/supercomputer_256.ecea2a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supercomputer_256.png
// module id = e0xA
// module chunks = 0